import { initialState } from "reducers/TaskManager/State";
import { TaskManager } from "constants/index";

const {
  GET_GROUPS,
  GET_GROUPS_FAIL,
  GET_GROUPS_SUCCESS,
  GET_PENDING_TASKS,
  GET_PENDING_TASKS_FAIL,
  GET_PENDING_TASKS_SUCCESS,
  GET_TASKS,
  GET_TASKS_FAIL,
  GET_TASKS_SUCCESS,
  MANAGE_TASK_DRAWER,
  CREATE_GROUP,
  CREATE_GROUP_SUCCESS,
  CREATE_GROUP_FAIL,
  UPDATE_GROUP,
  UPDATE_GROUP_SUCCESS,
  UPDATE_GROUP_FAIL,
  GET_TASK_HISTORY,
  GET_TASK_HISTORY_FAIL,
  GET_TASK_HISTORY_SUCCESS,
  GET_INSTANCE_HISTORY,
  GET_INSTANCE_HISTORY_FAIL,
  GET_INSTANCE_HISTORY_SUCCESS,
  SAVE_TASK_INSTANCE,
  SAVE_TASK_INSTANCE_FAIL,
  SAVE_TASK_INSTANCE_SUCCESS,
  GET_OPERATIONS_HANDLERS,
  GET_OPERATIONS_HANDLERS_SUCCESS,
  GET_OPERATIONS_HANDLERS_FAIL,
  GET_USERS,
  GET_USERS_SUCCESS,
  GET_USERS_FAIL,
  CREATE_TASK,
  CREATE_TASK_FAIL,
  CREATE_TASK_SUCCESS,
  UPDATE_TASK,
  UPDATE_TASK_FAIL,
  UPDATE_TASK_SUCCESS,
  SEND_EMAIL,
  SEND_EMAIL_FAIL,
  SEND_EMAIL_SUCCESS,
  RUN_TASK,
  RUN_TASK_FAIL,
  RUN_TASK_SUCCESS,
  DELETE_TASK,
  DELETE_TASK_FAIL,
  DELETE_TASK_SUCCESS,
  GET_SCRIPTS,
  GET_SCRIPTS_SUCCESS,
  GET_SCRIPTS_FAIL,
} = TaskManager;

export default (state = initialState, { payload, type }: any) => {
  switch (type) {
    case GET_GROUPS:
      return Object.assign({}, state, {
        groups: {
          ...initialState.groups,
          isLoading: true,
        },
      });
    case GET_GROUPS_SUCCESS:
      return Object.assign({}, state, {
        groups: {
          data: payload.data,
          isLoading: false,
        },
      });
    case GET_GROUPS_FAIL:
      return Object.assign({}, state, {
        groups: {
          ...state.groups,
          isLoading: false,
        },
      });
    case GET_PENDING_TASKS:
      return Object.assign({}, state, {
        pendingTasks: {
          ...initialState.pendingTasks,
          isLoading: true,
        },
      });
    case GET_PENDING_TASKS_SUCCESS:
      return Object.assign({}, state, {
        pendingTasks: {
          data: payload.data,
          isLoading: false,
        },
      });
    case GET_PENDING_TASKS_FAIL:
      return Object.assign({}, state, {
        pendingTasks: {
          ...state.pendingTasks,
          isLoading: false,
        },
      });
    case GET_TASKS:
      return Object.assign({}, state, {
        tasks: {
          ...initialState.tasks,
          isLoading: true,
        },
      });
    case GET_TASKS_SUCCESS:
      return Object.assign({}, state, {
        tasks: {
          data: payload.data,
          isLoading: false,
        },
      });
    case GET_TASKS_FAIL:
      return Object.assign({}, state, {
        tasks: {
          ...state.tasks,
          isLoading: false,
        },
      });
    case MANAGE_TASK_DRAWER:
      return Object.assign({}, state, {
        drawerInfo: {
          ...state.drawerInfo,
          ...payload.data,
          visible: !state.drawerInfo.visible,
        },
      });
    case CREATE_GROUP:
      return Object.assign({}, state, {
        group: {
          ...state.group,
          isLoading: true,
        },
      });
    case CREATE_GROUP_SUCCESS:
      return Object.assign({}, state, {
        group: {
          ...state.group,
          isLoading: false,
        },
        drawerInfo: {
          ...state.drawerInfo,
          visible: false,
        },
      });
    case CREATE_GROUP_FAIL:
      return Object.assign({}, state, {
        group: {
          ...state.group,
          isLoading: false,
        },
      });
    case UPDATE_GROUP:
      return Object.assign({}, state, {
        group: {
          ...state.group,
          isLoading: true,
        },
      });
    case UPDATE_GROUP_SUCCESS:
      return Object.assign({}, state, {
        group: {
          ...state.group,
          isLoading: false,
        },
        drawerInfo: {
          ...state.drawerInfo,
          visible: false,
        },
      });
    case UPDATE_GROUP_FAIL:
      return Object.assign({}, state, {
        group: {
          ...state.group,
          isLoading: false,
        },
      });
    case GET_TASK_HISTORY:
      return Object.assign({}, state, {
        taskHistory: {
          ...initialState.taskHistory,
          isLoading: true,
        },
      });
    case GET_TASK_HISTORY_SUCCESS:
      return Object.assign({}, state, {
        taskHistory: {
          data: payload.data,
          isLoading: false,
        },
      });
    case GET_TASK_HISTORY_FAIL:
      return Object.assign({}, state, {
        taskHistory: {
          ...state.taskHistory,
          isLoading: false,
        },
      });
    case GET_INSTANCE_HISTORY:
      return Object.assign({}, state, {
        instanceHistory: {
          ...initialState.instanceHistory,
          isLoading: true,
        },
      });
    case GET_INSTANCE_HISTORY_SUCCESS:
      return Object.assign({}, state, {
        instanceHistory: {
          data: payload.data,
          isLoading: false,
        },
      });
    case GET_INSTANCE_HISTORY_FAIL:
      return Object.assign({}, state, {
        instanceHistory: {
          ...state.instanceHistory,
          isLoading: false,
        },
      });
    case SAVE_TASK_INSTANCE:
      return Object.assign({}, state, {
        taskInstance: {
          ...state.taskInstance,
          isLoading: true,
        },
      });
    case SAVE_TASK_INSTANCE_SUCCESS:
      return Object.assign({}, state, {
        taskInstance: {
          data: payload.data,
          isLoading: false,
        },
        drawerInfo: {
          ...state.drawerInfo,
          visible: false,
        },
      });
    case SAVE_TASK_INSTANCE_FAIL:
      return Object.assign({}, state, {
        taskInstance: {
          ...state.taskInstance,
          isLoading: false,
        },
      });
    case GET_OPERATIONS_HANDLERS:
      return Object.assign({}, state, {
        operationsHandlers: {
          ...initialState.operationsHandlers,
          isLoading: true,
        },
      });
    case GET_OPERATIONS_HANDLERS_SUCCESS:
      return Object.assign({}, state, {
        operationsHandlers: {
          data: payload.data,
          isLoading: false,
        },
      });
    case GET_OPERATIONS_HANDLERS_FAIL:
      return Object.assign({}, state, {
        operationsHandlers: {
          ...state.operationsHandlers,
          isLoading: false,
        },
      });
    case GET_USERS:
      return Object.assign({}, state, {
        users: {
          ...initialState.users,
          isLoading: true,
        },
      });
    case GET_USERS_SUCCESS:
      return Object.assign({}, state, {
        users: {
          data: payload.data,
          isLoading: false,
        },
      });
    case GET_USERS_FAIL:
      return Object.assign({}, state, {
        users: {
          ...state.users,
          isLoading: false,
        },
      });
    case CREATE_TASK:
      return Object.assign({}, state, {
        task: {
          ...initialState.task,
          isSaving: true,
        },
      });
    case CREATE_TASK_SUCCESS:
      return Object.assign({}, state, {
        task: {
          isSaving: false,
        },
        drawerInfo: {
          ...state.drawerInfo,
          visible: false,
        },
      });
    case CREATE_TASK_FAIL:
      return Object.assign({}, state, {
        task: {
          isSaving: false,
        },
      });
    case UPDATE_TASK:
      return Object.assign({}, state, {
        task: {
          ...initialState.task,
          isSaving: true,
        },
      });
    case UPDATE_TASK_SUCCESS:
      return Object.assign({}, state, {
        task: {
          isSaving: false,
        },
        drawerInfo: {
          ...state.drawerInfo,
          visible: false,
        },
      });
    case UPDATE_TASK_FAIL:
      return Object.assign({}, state, {
        task: {
          isSaving: false,
        },
      });
    case SEND_EMAIL:
      return Object.assign({}, state, {
        newEmail: {
          ...state.newEmail,
          isSending: true,
        },
      });
    case SEND_EMAIL_SUCCESS:
      return Object.assign({}, state, {
        newEmail: {
          ...state.newEmail,
          isSending: false,
          data: payload.data,
        },
      });
    case SEND_EMAIL_FAIL:
      return Object.assign({}, state, {
        newEmail: {
          ...state.newEmail,
          isSending: false,
        },
      });
    case RUN_TASK:
      return Object.assign({}, state, {
        taskRun: {
          ...state.taskRun,
          isRunning: true,
        },
      });
    case RUN_TASK_SUCCESS:
      return Object.assign({}, state, {
        taskRun: {
          ...state.taskRun,
          isRunning: false,
          data: payload.data,
        },
      });
    case RUN_TASK_FAIL:
      return Object.assign({}, state, {
        taskRun: {
          ...state.taskRun,
          isRunning: false,
        },
      });
    case DELETE_TASK:
      return Object.assign({}, state, {
        taskDelete: {
          ...state.taskDelete,
          isDeleting: true,
        },
      });
    case DELETE_TASK_SUCCESS:
      return Object.assign({}, state, {
        taskDelete: {
          ...state.taskDelete,
          isDeleting: false,
          data: payload.data,
        },
        drawerInfo: {
          ...state.drawerInfo,
          visible: false,
        },
      });
    case DELETE_TASK_FAIL:
      return Object.assign({}, state, {
        taskDelete: {
          ...state.taskDelete,
          isDeleting: false,
        },
      });
    case GET_SCRIPTS:
      return Object.assign({}, state, {
        scripts: {
          ...state.scripts,
          isLoading: true,
        },
      });
    case GET_SCRIPTS_SUCCESS:
      return Object.assign({}, state, {
        scripts: {
          ...state.scripts,
          isLoading: false,
          data: payload.data,
        },
      });
    case GET_SCRIPTS_FAIL:
      return Object.assign({}, state, {
        scripts: {
          ...state.scripts,
          isLoading: false,
        },
      });
    default:
      return state;
  }
};
